import api from "./index";

export async function getRaffles(params) {
  return api.get("/raffles", { params });
}

export async function getRaffleID(raffleID) {
  return api.get(`/raffles/${raffleID}`);
}
